import React, { Component } from 'react'
import { Formik, Form } from 'formik'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'
import UnauthorizedComponent from '../general/UnauthorizedComponent.jsx'

class SociedadFormularioComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: this.props.match.params.id,
      correo: '', password: '', generacion: '', domicilios: [],
      opinionCumplimiento: '', pendientes: '', razonSocial: '',
      revisionFiscal: '', status: '', statusContabilidad: '',
      responsableContabilidad: '', auxiliarContable: '', tipo: '',
      situacion: '', rfc: '', clientes: [], personasFisicas: [],
      datosConstitucion: '', objetoSocial: '', clausulaExtranjeria: '',
      capitalSocialFijo: '', capitalSocialVariable: 'Ilimitado',
      valorNominal: '', distribucionCapital: '', allDomicilios: [],
      allClientes: [], loading: false, vigenciaFiel: '', telefono: '',
      telefonoDesignadoCliente: '', buzonTributarioStatus: '',
      noAplica: false, fechaSuspension: '', fechaEntrega: '',
      unauthorized: false,
    }
    this.onSubmit = this.onSubmit.bind(this)
  }

  removeDuplicates = (arr, prop) => arr.reduce((acc, cur) => {
    if (!acc.find(o => o[prop] === cur[prop])) acc.push(cur)
    return acc
  }, [])

  componentDidMount() {
    if (!AuthenticationService.haveAuthorization("WRITE_SOCIEDADES")) {
      this.setState({ unauthorized: true })
      return
    }
    ElementsDataService.retrieveAllElements("clientes")
      .then(r => this.setState({ allClientes: r.data }))
    ElementsDataService.retrieveAllElements("domicilios")
      .then(r => this.setState({ allDomicilios: r.data }))

    if (Number(this.props.match.params.id) === -1) return

    ElementsDataService.retrieveElement("sociedades", this.state.id)
      .then(r => {
        const d = r.data
        this.setState({
          correo: d.correo || '', password: d.password || '',
          generacion: d.generacion || '', domicilios: d.domicilios || [],
          opinionCumplimiento: d.opinionCumplimiento || '', pendientes: d.pendientes || '',
          razonSocial: d.razonSocial || '', revisionFiscal: d.revisionFiscal || '',
          status: d.status || '', tipo: d.tipo || '', situacion: d.situacion || '',
          rfc: d.rfc || '', clientes: d.clientes || [],
          datosConstitucion: d.datosConstitucion || '', objetoSocial: d.objetoSocial || '',
          clausulaExtranjeria: d.clausulaExtranjeria || '',
          capitalSocialFijo: d.capitalSocialFijo || '',
          capitalSocialVariable: d.capitalSocialVariable || 'Ilimitado',
          valorNominal: d.valorNominal || '', distribucionCapital: d.distribucionCapital || '',
          vigenciaFiel: d.vigenciaFiel || '', statusContabilidad: d.statusContabilidad || '',
          responsableContabilidad: d.responsableContabilidad || '',
          auxiliarContable: d.auxiliarContable || '', telefono: d.telefono || '',
          telefonoDesignadoCliente: d.telefonoDesignadoCliente || '',
          buzonTributarioStatus: d.buzonTributarioStatus || '',
          fechaSuspension: d.fechaSuspension || '', fechaEntrega: d.fechaEntrega || '',
        })
      })
  }

  onSubmit() {
    let msg = ""
    if (!this.state.razonSocial) msg += "Debe especificar una Razón Social\n"
    if (!this.state.rfc) msg += "Debe especificar un RFC\n"
    if (msg) { alert(msg); return }

    this.setState({ loading: true })
    const s = { ...this.state }
    delete s.allDomicilios; delete s.allClientes; delete s.loading; delete s.noAplica

    if (Number(this.state.id) === -1) {
      ElementsDataService.createElement("sociedades", s)
        .then(r => {
          if (r.data.message === "Created") this.props.history.push(`/sociedades/reportes/${r.data.id}`)
          else { alert(r.data.message); this.setState({ loading: false }) }
        })
    } else {
      ElementsDataService.updateElement("sociedades", this.state.id, s)
        .then(() => this.props.history.push(`/sociedades/reportes/${this.state.id}`))
    }
  }

  set = (field) => (e) => this.setState({ [field]: e.target.value })
  setUpper = (field) => (e) => this.setState({ [field]: e.target.value.toUpperCase() })

  toggleNoAplica(checked) {
    if (checked) {
      this.setState({ noAplica: true, capitalSocialFijo: 'N/A', capitalSocialVariable: 'N/A', valorNominal: 'N/A', distribucionCapital: 'N/A' })
    } else {
      this.setState({ noAplica: false, capitalSocialFijo: '', capitalSocialVariable: '', valorNominal: '', distribucionCapital: '' })
    }
  }

  render() {
    const s = this.state
    const isNew = Number(s.id) === -1
    const canEditDomicilios = AuthenticationService.haveAuthorization("SUPERVISOR_DOMICILIOS")

    return (
      <div style={styles.root}>
        {this.state.unauthorized && <UnauthorizedComponent history={this.props.history} />}
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
          .sof-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
          .sof-input {
            width: 100%; padding: 10px 14px;
            background: white; border: 1px solid #e2e8f0; border-radius: 10px;
            font-size: 0.875rem; color: #1e293b; outline: none;
            transition: all 0.2s; font-family: 'Inter', sans-serif;
          }
          .sof-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
          .sof-input:disabled { background: #f8fafc; color: #94a3b8; cursor: not-allowed; }
          .sof-select {
            width: 100%; padding: 10px 14px;
            background: white; border: 1px solid #e2e8f0; border-radius: 10px;
            font-size: 0.875rem; color: #1e293b; outline: none; cursor: pointer;
            transition: all 0.2s; font-family: 'Inter', sans-serif; appearance: none;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2394a3b8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
            background-repeat: no-repeat; background-position: right 12px center;
            padding-right: 36px;
          }
          .sof-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
          .sof-textarea {
            width: 100%; padding: 10px 14px; min-height: 90px; resize: vertical;
            background: white; border: 1px solid #e2e8f0; border-radius: 10px;
            font-size: 0.875rem; color: #1e293b; outline: none;
            transition: all 0.2s; font-family: 'Inter', sans-serif; line-height: 1.6;
          }
          .sof-textarea:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
          .sof-label { font-size: 0.72rem; font-weight: 700; color: #64748b; letter-spacing: 0.8px; text-transform: uppercase; margin-bottom: 6px; display: block; }
          .sof-field { display: flex; flex-direction: column; }
          .chip-wrap { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
          .chip {
            display: inline-flex; align-items: center; gap: 5px;
            background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 20px;
            padding: 4px 10px 4px 5px; font-size: 0.75rem; color: #2563eb;
          }
          .chip button {
            background: #bfdbfe; border: none; border-radius: 50%; width: 15px; height: 15px;
            cursor: pointer; font-size: 0.6rem; color: #1d4ed8; padding: 0;
            display: flex; align-items: center; justify-content: center;
          }
          .chip button:hover { background: #ef4444; color: white; }
          .chip-dom {
            display: inline-flex; align-items: center; gap: 5px;
            background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 20px;
            padding: 4px 10px 4px 5px; font-size: 0.75rem; color: #16a34a;
          }
          .chip-dom button {
            background: #bbf7d0; border: none; border-radius: 50%; width: 15px; height: 15px;
            cursor: pointer; font-size: 0.6rem; color: #15803d; padding: 0;
            display: flex; align-items: center; justify-content: center;
          }
          .chip-dom button:hover { background: #ef4444; color: white; }
          .btn-save {
            padding: 12px 32px; background: linear-gradient(135deg, #2563eb, #3b82f6);
            border: none; border-radius: 10px; color: white; font-weight: 700;
            font-size: 0.88rem; cursor: pointer; transition: all 0.2s;
            font-family: 'Inter', sans-serif; box-shadow: 0 4px 14px rgba(59,130,246,0.35);
            letter-spacing: 0.5px;
          }
          .btn-save:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(59,130,246,0.45); }
          .btn-save:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
          .btn-cancel {
            padding: 12px 24px; background: white; border: 1px solid #e2e8f0;
            border-radius: 10px; color: #64748b; font-weight: 600; font-size: 0.88rem;
            cursor: pointer; transition: all 0.2s; font-family: 'Inter', sans-serif;
          }
          .btn-cancel:hover { border-color: #94a3b8; color: #334155; }
          @keyframes spin { to { transform: rotate(360deg); } }
          .spinner { width: 32px; height: 32px; border: 3px solid #e2e8f0; border-top-color: #3b82f6; border-radius: 50%; animation: spin 0.7s linear infinite; }
        `}</style>

        <div className="sof-root" style={styles.inner}>

          {/* Header */}
          <div style={styles.header}>
            <div>
              <p style={styles.breadcrumb}>
                <span style={{ cursor: 'pointer', color: '#3b82f6' }} onClick={() => this.props.history.push('/sociedades')}>Sociedades</span>
                <span style={{ margin: '0 8px', color: '#cbd5e1' }}>›</span>
                <span>{isNew ? 'Nueva Sociedad' : s.razonSocial || 'Editar'}</span>
              </p>
              <h1 style={styles.title}>{isNew ? 'Nueva Sociedad' : (s.razonSocial || 'Editar Sociedad')}</h1>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
              <button className="btn-save" onClick={this.onSubmit} disabled={s.loading}>
                {s.loading ? '⏳ Guardando...' : '✓ Guardar'}
              </button>
            </div>
          </div>

          <Formik initialValues={{}} onSubmit={this.onSubmit} enableReinitialize>
            {() => (
              <Form>
                <div style={styles.sections}>

                  {/* ── SECCIÓN 1: Datos generales ── */}
                  <Section title="Datos Generales" icon="🏢">
                    <Grid cols={2}>
                      <Field label="Razón Social *" required>
                        <input className="sof-input" value={s.razonSocial} onChange={this.setUpper('razonSocial')} placeholder="EMPRESA SA DE CV" />
                      </Field>
                      <Field label="RFC *">
                        <input className="sof-input" value={s.rfc} onChange={this.setUpper('rfc')} placeholder="EMP000101ABC" autoComplete="off" />
                      </Field>
                    </Grid>
                    <Grid cols={2}>
                      <Field label="Tipo">
                        <input className="sof-input" value={s.tipo} onChange={this.set('tipo')} placeholder="SA de CV, SAPI, etc." />
                      </Field>
                      <Field label="Situación">
                        <input className="sof-input" value={s.situacion} onChange={this.set('situacion')} placeholder="Situación" />
                      </Field>
                    </Grid>
                    <Grid cols={1}>
                      <Field label="Datos de Constitución">
                        <textarea className="sof-textarea" value={s.datosConstitucion} onChange={this.set('datosConstitucion')} placeholder="Datos de la escritura..." />
                      </Field>
                    </Grid>
                    <Grid cols={1}>
                      <Field label="Objeto Social">
                        <textarea className="sof-textarea" value={s.objetoSocial} onChange={this.set('objetoSocial')} placeholder="Objeto social..." />
                      </Field>
                    </Grid>
                    <Grid cols={2}>
                      <Field label="Cláusula Extranjería">
                        <select className="sof-select" value={s.clausulaExtranjeria} onChange={this.set('clausulaExtranjeria')}>
                          <option value="">— Seleccionar —</option>
                          <option>Admisión de extranjeros</option>
                          <option>Exclusión de extranjeros</option>
                        </select>
                      </Field>
                      <Field label="Revisión Fiscal">
                        <select className="sof-select" value={s.revisionFiscal} onChange={this.set('revisionFiscal')}>
                          <option value="">— Seleccionar —</option>
                          <option value="SI">SI</option>
                          <option value="NO">NO</option>
                        </select>
                      </Field>
                    </Grid>
                  </Section>

                  {/* ── SECCIÓN 2: Estatus ── */}
                  <Section title="Estatus" icon="📊">
                    <Grid cols={3}>
                      <Field label="Estatus Legal">
                        <select className="sof-select" value={s.status} onChange={this.set('status')}>
                          <option value="">— Todos —</option>
                          {['Activa','Inactiva','Susp>L...','Liqx','P.E.','React','N/A'].map(o => <option key={o}>{o}</option>)}
                        </select>
                      </Field>
                      <Field label="Estatus Contable">
                        <select className="sof-select" value={s.statusContabilidad} onChange={this.set('statusContabilidad')}>
                          <option value="">— Todos —</option>
                          {['ACTIVA','SIN UTILIZAR','INACTIVA','PROCESO LIQUIDACION','LIQUIDADA','PROCESO SUSPENSION','SUSPENDIDA','VENDIDA','DEVUELTA','NO REVISION'].map(o => <option key={o}>{o}</option>)}
                        </select>
                      </Field>
                      <Field label="Estatus Buzón Tributario">
                        <select className="sof-select" value={s.buzonTributarioStatus} onChange={this.set('buzonTributarioStatus')}>
                          <option value="">— Seleccionar —</option>
                          <option value="ACTIVO">ACTIVO</option>
                          <option value="INACTIVO">INACTIVO</option>
                        </select>
                      </Field>
                    </Grid>
                    {s.statusContabilidad === 'SUSPENDIDA' && (
                      <Grid cols={3}>
                        <Field label="Fecha Suspensión">
                          <input className="sof-input" type="date" value={s.fechaSuspension} onChange={this.set('fechaSuspension')} />
                        </Field>
                      </Grid>
                    )}
                    <Grid cols={1}>
                      <Field label="Pendientes">
                        <input className="sof-input" value={s.pendientes} onChange={this.set('pendientes')} placeholder="Pendientes..." />
                      </Field>
                    </Grid>
                  </Section>

                  {/* ── SECCIÓN 3: Asignación ── */}
                  <Section title="Asignación" icon="📁">
                    <Grid cols={2}>
                      <Field label="Responsable Contabilidad">
                        <input className="sof-input" value={s.responsableContabilidad} onChange={this.setUpper('responsableContabilidad')} placeholder="Nombre responsable" />
                      </Field>
                      <Field label="Auxiliar Contable">
                        <input className="sof-input" value={s.auxiliarContable} onChange={this.setUpper('auxiliarContable')} placeholder="Auxiliar" />
                      </Field>
                    </Grid>
                    <Grid cols={2}>
                      <Field label="Proyectos">
                        <select className="sof-select" onChange={e => {
                          const found = s.allClientes.find(c => String(c.id) === e.target.value)
                          if (found && !s.clientes.find(c => c.id === found.id))
                            this.setState({ clientes: [...s.clientes, found] })
                          e.target.value = ""
                        }}>
                          <option value="">Agregar proyecto...</option>
                          {s.allClientes.map(c => <option key={c.id} value={c.id}>{c.nombreCliente}</option>)}
                        </select>
                        <div className="chip-wrap">
                          {s.clientes.map(c => (
                            <span key={c.id} className="chip">
                              <button type="button" onClick={() => this.setState({ clientes: s.clientes.filter(x => x.id !== c.id) })}>✕</button>
                              {c.nombreCliente}
                            </span>
                          ))}
                        </div>
                      </Field>
                      <Field label="Fecha Entrega a Cliente">
                        <input className="sof-input" type="date" value={s.fechaEntrega} onChange={this.set('fechaEntrega')} />
                      </Field>
                    </Grid>
                    <Grid cols={2}>
                      <Field label={`Domicilios${!canEditDomicilios ? ' (solo lectura)' : ''}`}>
                        <select className="sof-select" disabled={!canEditDomicilios} onChange={e => {
                          const found = s.allDomicilios.find(d => String(d.id) === e.target.value)
                          if (found && !s.domicilios.find(d => d.id === found.id))
                            this.setState({ domicilios: [...s.domicilios, found] })
                          e.target.value = ""
                        }}>
                          <option value="">Agregar domicilio...</option>
                          {s.allDomicilios.map(d => (
                            <option key={d.id} value={d.id}>
                              {d.calle} {d.numeroExt}{d.numeroInterior ? ` Int: ${d.numeroInterior}` : ''} {d.colonia}
                            </option>
                          ))}
                        </select>
                        <div className="chip-wrap">
                          {s.domicilios.map(d => (
                            <span key={d.id} className="chip-dom">
                              {canEditDomicilios && <button type="button" onClick={() => this.setState({ domicilios: s.domicilios.filter(x => x.id !== d.id) })}>✕</button>}
                              {d.calle} {d.numeroExt}, {d.colonia}
                            </span>
                          ))}
                        </div>
                      </Field>
                      <Field label="Generación">
                        <input className="sof-input" value={s.generacion} onChange={this.set('generacion')} placeholder="Generación" />
                      </Field>
                    </Grid>
                  </Section>

                  {/* ── SECCIÓN 4: Contacto ── */}
                  <Section title="Contacto & FIEL" icon="📞">
                    <Grid cols={3}>
                      <Field label="Correo electrónico">
                        <input className="sof-input" type="email" value={s.correo} onChange={this.set('correo')} placeholder="correo@empresa.com" autoComplete="off" />
                      </Field>
                      <Field label="Contraseña correo">
                        <input className="sof-input" type="text" value={s.password} onChange={this.set('password')} placeholder="••••••••" autoComplete="off" />
                      </Field>
                      <Field label="Vigencia FIEL">
                        <input className="sof-input" type="date" value={s.vigenciaFiel} onChange={this.set('vigenciaFiel')} />
                      </Field>
                    </Grid>
                    <Grid cols={2}>
                      <Field label="Teléfono">
                        <input className="sof-input" value={s.telefono} onChange={this.set('telefono')} placeholder="55 1234 5678" />
                      </Field>
                      <Field label="Teléfono designado por el cliente">
                        <input className="sof-input" value={s.telefonoDesignadoCliente} onChange={this.set('telefonoDesignadoCliente')} placeholder="55 9876 5432" />
                      </Field>
                    </Grid>
                  </Section>

                  {/* ── SECCIÓN 5: Capital Social ── */}
                  <Section title="Capital Social" icon="💰">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, padding: '10px 14px', background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0' }}>
                      <input
                        type="checkbox" id="noAplica"
                        checked={s.noAplica}
                        onChange={e => this.toggleNoAplica(e.target.checked)}
                        style={{ width: 16, height: 16, cursor: 'pointer', accentColor: '#3b82f6' }}
                      />
                      <label htmlFor="noAplica" style={{ fontSize: '0.85rem', color: '#475569', cursor: 'pointer', fontWeight: 500 }}>
                        No aplican los siguientes campos
                      </label>
                    </div>
                    <Grid cols={4}>
                      <Field label="Capital Social Fijo">
                        <input className="sof-input" value={s.capitalSocialFijo} onChange={this.set('capitalSocialFijo')} placeholder="$0.00" disabled={s.noAplica} />
                      </Field>
                      <Field label="Capital Social Variable">
                        <input className="sof-input" value={s.capitalSocialVariable} onChange={this.set('capitalSocialVariable')} placeholder="Ilimitado" disabled={s.noAplica} />
                      </Field>
                      <Field label="Valor Nominal">
                        <input className="sof-input" value={s.valorNominal} onChange={this.set('valorNominal')} placeholder="$0.00" disabled={s.noAplica} />
                      </Field>
                      <Field label="Distribución Capital">
                        <input className="sof-input" value={s.distribucionCapital} onChange={this.set('distribucionCapital')} placeholder="Distribución" disabled={s.noAplica} />
                      </Field>
                    </Grid>
                  </Section>

                </div>

                {/* Footer botones */}
                <div style={styles.footer}>
                  <button type="button" className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
                  <button type="button" className="btn-save" onClick={this.onSubmit} disabled={s.loading}>
                    {s.loading ? '⏳ Guardando...' : '✓ Guardar Sociedad'}
                  </button>
                </div>

              </Form>
            )}
          </Formik>
        </div>
      </div>
    )
  }
}

// Componentes helper
const Section = ({ title, icon, children }) => (
  <div style={sectionStyle}>
    <div style={sectionHeader}>
      <span style={{ fontSize: '1.1rem' }}>{icon}</span>
      <h2 style={sectionTitle}>{title}</h2>
    </div>
    <div style={{ padding: '20px 24px' }}>{children}</div>
  </div>
)

const Grid = ({ cols, children }) => (
  <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 16, marginBottom: 16 }}>
    {children}
  </div>
)

const Field = ({ label, children }) => (
  <div className="sof-field">
    <label className="sof-label">{label}</label>
    {children}
  </div>
)

const sectionStyle = { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, marginBottom: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }
const sectionHeader = { display: 'flex', alignItems: 'center', gap: 10, padding: '14px 24px', borderBottom: '1px solid #f1f5f9', background: '#fafcff' }
const sectionTitle = { margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#1e293b' }

const styles = {
  root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
  inner: { maxWidth: 960, margin: '0 auto' },
  header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 },
  breadcrumb: { margin: '0 0 4px', fontSize: '0.78rem', color: '#94a3b8' },
  title: { margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0f172a' },
  sections: { display: 'flex', flexDirection: 'column', gap: 0 },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '20px 0', marginTop: 4 },
}

export default SociedadFormularioComponent
